
import { apiListProcessLevel } from 'redux/api/business_process';

function useFetch({
  levelParent,
}) {
  const getLoadOptions = async (search, loadedOptions, { page = 1 } = {}) => {
    const response = await apiListProcessLevel({
      page,
      page_size: 20,
      board_id: localStorage.getItem('board_id'),
      level: levelParent,
      // search,
    });

    const {
      rows, count, page: currentPage, pagesize,
    } = response;
    const isHasMore = currentPage * pagesize < count;
    const dataMapping = rows.map((item) => ({
      label: item.name,
      value: item.process_id,
    }));

    return {
      options: dataMapping,
      hasMore: isHasMore,
      additional: { page: page + 1 },
    };
  };

  return { getLoadOptions };
}

export default useFetch;
